export default "__VITE_ASSET__BFMiCDk5__"